import { makeStyles } from "@fluentui/react-components";
import { primer } from "./primerDarkTheme";

export const useProjectSelectorStyles = makeStyles({
    wrapper: { position: "relative", display: "inline-flex" },
    trigger: {
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        padding: "3px 6px 3px 8px",
        fontSize: "14px",
        fontWeight: 500,
        color: primer.fg,
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",
        whiteSpace: "nowrap",
        lineHeight: "normal",
        "&:hover": { opacity: 0.8 },
    },
    triggerCaret: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "10px",
        color: primer.fgMuted,
        transform: "rotate(180deg)",
    },
    dropdown: {
        position: "absolute",
        top: "calc(100% + 4px)",
        left: "0",
        minWidth: "260px",
        backgroundColor: primer.surface,
        border: `1px solid ${primer.border}`,
        borderRadius: "8px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
        zIndex: 200,
        overflow: "hidden",
    },
    sectionHeader: {
        padding: "10px 12px 6px",
        fontSize: "12px",
        fontWeight: 600,
        color: primer.fgMuted,
    },
    list: { listStyle: "none", margin: 0, padding: 0 },
    item: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px 12px",
        fontSize: "14px",
        color: primer.fg,
        cursor: "pointer",
        "&:hover": { backgroundColor: "#1c2128" },
    },
    itemSelected: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px 12px",
        fontSize: "14px",
        color: primer.fg,
        cursor: "pointer",
        backgroundColor: "#1c2128",
    },
    checkIcon: { width: "16px", flexShrink: 0, fontSize: "14px", color: primer.green },
    checkPlaceholder: { width: "16px", flexShrink: 0 },
    itemName: { flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
    divider: { height: "1px", backgroundColor: primer.border, margin: "4px 0" },
    linkItem: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        padding: "8px 12px",
        fontSize: "14px",
        color: primer.fgMuted,
        cursor: "pointer",
        textDecoration: "none",
        background: "none",
        border: "none",
        width: "100%",
        textAlign: "left",
        "&:hover": { backgroundColor: "#1c2128", color: primer.fg },
    },
    externalIcon: { fontSize: "12px", flexShrink: 0 },
    loading: { padding: "12px", fontSize: "13px", color: primer.fgMuted, textAlign: "center" as const },
    error: { padding: "12px", fontSize: "13px", color: primer.red, textAlign: "center" as const },
});
